(function () {

    var sweepstakesPrizingService = function ($http) {

        var randomString = function randomString(length, chars) {
            var result = '';
            for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        var index = function (id) {
            var uri = '/api/v1/experience/sweepstakes/' + id + '/prize-pool';
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        var store = function (id, data) {
            return $http.post('/api/v1/experience/sweepstakes/' + id + '/prize-pool', data, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        var update = function (id, poolId, data) {
            return $http.put('/api/v1/experience/sweepstakes/' + id + '/prize-pool/' + poolId, data, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        var indexType = function (id, poolId) {
            return $http.get(
                '/api/v1/experience/sweepstakes/' + id + '/prize-pool/' + poolId + '/prize-type',
                {cache: false, headers: { 'Cache-Control': 'no-cache' }}
            ).then(function (response) {
                return response.data;
            });
        };

        var storeType = function (id, poolId, data) {
            return $http.post(
                '/api/v1/experience/sweepstakes/' + id + '/prize-pool/' + poolId + '/prize-type',
                data,
                {cache: false, headers: { 'Cache-Control': 'no-cache' }}
            ).then(function (response) {
                return response.data;
            });
        };

        return {
            index: index,
            store: store,
            update: update,
            indexType: indexType,
            storeType: storeType
        };

    };

    var app = angular.module('TetherApp');

    app.factory('sweepstakesPrizingService', [
        '$http',
        sweepstakesPrizingService
    ]);

}());
